export const FETCH_DETAILS = 'merchantsReconciliationDetails/FETCH_DETAILS';
